<!--急救车 编辑 / 补写-->
<template>
  <div v-if="showContent">
    <basic-info/>
    <ambulance-status v-show="!isAddPatient"/>
    <situation ref="situationRef"/>
    <drug ref="drugRef"/>
    <check ref="checkRef"/>
    <hospital-emergency ref="hospitalRef"/>
    <el-button class="button-patient-save" @click="saveData">保存</el-button>

    <my-dialog
      :dialog-carted="dialogFormVisible"
      form-title="提示"
      :width="320"
      @confirmOk="dialogFormVisible = false"
    >
      <template #content>
        <div>保存成功</div>
      </template>
    </my-dialog>
  </div>
</template>

<script>
import BasicInfo from "@components/patients/BasicInfo.vue";
import Situation from "@components/patients/Situation.vue";
import AmbulanceStatus from "@/components/patients/AmbulanceStatus.vue";
import Drug from "@components/patients/Drug.vue";
import Check from "@components/patients/Check.vue";
import MyDialog from "@components/customDialog/MyDialog.vue";
import HospitalEmergency from "@components/patients/HospitalEmergency";
import { editAmbulancePatientInfo, getPatient } from "@/api/hospitalList";
import { showWindowMessage } from "@utils/notification";
import { mapState } from "vuex";
import "@/assets/css/patients.scss";

export default {
  name: "AddPatient",
  components: {
    BasicInfo,
    Situation,
    AmbulanceStatus,
    Drug,
    Check,
    MyDialog,
    HospitalEmergency
  },
  data() {
    return {
      showContent: false,
      patientID: "",
      patient: {},
      dialogFormVisible: false,
      isAddPatient: false, // 判断是不是编辑
      isWriteMore: false, // 判断是不是补写
    };
  },
  computed: {
    ...mapState({
      userInfo: "userInfo"
    })
  },
  mounted() {
    const all = this.$route.path.split("/");
    this.isAddPatient = all[1] === "addPatient";
    this.isWriteMore = all[1] === "writeMore";
    this.patientID = this.$route.params.id;
    this.getPatientInfo();
  },
  methods: {
    async getPatientInfo() {
      try {
        const patient = await getPatient(this.patientID);
        patient.pageInfo = {
          isWriteMore: this.isWriteMore,
          isAddPatient: this.isAddPatient,
          isShowPatient: this.isShowPatient,
        };
        this.patient = patient;
        this.$store.commit("updateShowOrEditPatientInfo", patient);
        this.showContent = true;
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },

    async saveData() {
      const {
        illness_level,
        fistCheck,
        details,
        pupil,
        awareness,
        temperature,
        breath: breathing,
        systolicPressure,
        diastolicPressure,
        bloodSuger
      } = this.$refs.situationRef.$refs.editRef.form;
      const operationM = this.$refs.drugRef.$refs.editRef.value;
      const {
        result, operation, outpatient_number
      } = this.$refs.hospitalRef.checkForm;
      const {
        bloodTest, xRay, Xlight, gastroscopy, room, operation: prepare
      } = this.$refs.checkRef.checkForm;
      const checkList = [];
      if (bloodTest) {
        checkList.push("验血");
      }
      if (xRay) {
        checkList.push("胸透");
      }
      if (gastroscopy) {
        checkList.push("肠胃镜");
      }
      if (Xlight) {
        checkList.push("X光");
      }
      const checkString = checkList.join("/");
      const data = {
        illness_level,
        fistCheck,
        details,
        pupil,
        awareness,
        temperature,
        breathing,
        systolicPressure,
        diastolicPressure,
        bloodSuger,
        id: this.userInfo.id,
        check: checkString,
        room,
        operationM,
        prepare,
        result, operate: operation, outpatient_number
      };
      try {
        const method = this.isWriteMore ? "PUT" : "POST";
        const { code, msg } = await editAmbulancePatientInfo(this.patientID, JSON.stringify(data), method);
        showWindowMessage(code === 200 ? 4 : 3, msg, this);
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
